module.exports = __webpack_public_path__ + "img/supplychain_specialSession.87f23a86.png";